<template>
    <div
        class="questionnaire-section"
        :class="`questionnaire-section-${questionnaireSection.id}`">
        <b-button
            class="btn-questionnaire-section-toggler"
            v-b-toggle="`questionnaire-section-${questionnaireSection.id}`"
            block
            variant="primary"
            @click="scrollToTopPanel">
            {{ questionnaireSection.title }}
        </b-button>

        <b-collapse
            :id="`questionnaire-section-${questionnaireSection.id}`"
            accordion="questionnaire-section"
            :visible="sectionIndex === 0"
            role="tabpanel">
            <div class="questionnaire-section-description">
                <design-2021-apprentice-display-html-component :html-content="questionnaireSection.description">
                </design-2021-apprentice-display-html-component>
            </div>

            <design-2021-questionnaire-question-component
                v-for="question of questionnaireSection.questions"
                :key="question.id"
                :question-in="question"
                @updated-question="updateAnswer">
            </design-2021-questionnaire-question-component>

            <div class="store-changes">
                <b-button
                    class="btn-save btn-store-questionnaire"
                    variant="primary"
                    @click="storeForm">
                    {{ $t('common.save') }}
                </b-button>
            </div>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'design-2021-questionnaire-section-component',
    props: {
        questionnaireSectionIn: {
            type: Object,
            required: true,
        },
        sectionIndex: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            questionnaireSection: this.questionnaireSectionIn,
        };
    },

    methods: {
        scrollToTopPanel() {
            Vue.nextTick(() => {
                const currentSection = $(`.questionnaire-section-${this.questionnaireSection.id}`);
                const siblings = [...currentSection[0].parentNode.children];
                let sectionIndex = null;

                for (const [index, sibling] of siblings.entries()) {
                    const classes = [...sibling.classList];
                    if (classes.indexOf(`questionnaire-section-${this.questionnaireSection.id}`) !== -1) {
                        sectionIndex = index;
                    }
                }
                const scrollPosition = sectionIndex * 69 + 21;
                $('.main-content').animate({ scrollTop: scrollPosition }, 1000);
            });
        },

        storeForm() {
            this.$emit('store-form');
        },

        updateAnswer(updatedQuestion) {
            this.questionnaireSection.questions = this.questionnaireSection.questions.map((question) => {
                if (question.id === updatedQuestion.id) {
                    question = updatedQuestion;
                }
                return question;
            });
            this.$emit('update-section', this.questionnaireSection);
        },
    },
};
</script>

<style scoped lang="scss">
.questionnaire-section {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.btn-questionnaire-section-toggler {
    position: relative;
    display: flex;
    flex-direction: column;
    line-height: 1;
    text-align: left;
    font-size: 1.125rem;
    font-weight: $font-weight-medium;

    &.collapsed {
        background-color: rgba($black, 0.1);
        border-color: rgba($black, 0.1);
    }

    &.not-collapsed {
        background-color: $primary;
        border-color: $primary;
    }
}

.questionnaire-section-description {
    margin: map-get($grid-gutter-spacing, 'fifteen');
    color: $text-muted-color;
    font-weight: $font-weight-medium;
}

.store-changes {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    margin-right: 31px;
}
</style>
